module.exports = __webpack_public_path__ + "static/media/Mirrored Wardrobes (5).5c267314.jpg";